export const cloneDesign = (design) => JSON.parse(JSON.stringify(design ?? null));

export const getDefaultProfileSignatureEmailOption = ({ emailOptions, loggedInEmail }) =>
	emailOptions.find((option) => option.normalizedEmail === loggedInEmail?.trim()?.toLowerCase()) ??
	emailOptions[0] ??
	null;

export const getUnlayerExport = (unlayer) =>
	new Promise((resolve, reject) => {
		if (!unlayer || typeof unlayer.exportHtml !== 'function') {
			reject(new Error('Unlayer editor is not ready.'));
			return;
		}

		unlayer.exportHtml((data) => {
			if (!data || typeof data !== 'object') {
				reject(new Error('Unable to export signature.'));
				return;
			}
			resolve({
				html: data?.html ?? '',
				design: data?.design ?? null,
			});
		});
	});
